import { Component, OnInit } from '@angular/core';
import { AgentNomineeHandlerComponent } from './agent-nominee.handler';
import { AgentService } from '../services/agent.service';

@Component({
  selector: 'sym-agent-nominee',
  templateUrl: './agent-nominee.component.html',
  styleUrls: ['./agent-nominee.component.scss'],
})
export class AgentNomineeComponent extends AgentNomineeHandlerComponent {
  constructor(agentService: AgentService) {
    super(agentService);
  }
}
